<template>
  <div class="help-tool-tip">
    <div
      class="icon"
      @mouseleave="show_help_tip = false"
      @mouseover="show_help_tip = true"
    >
      <img src="@/assets/icons/help.svg" alt />
    </div>
    <div class="help-text" :class="position" v-show="show_help_tip && data">
      {{ data | validate }}
    </div>
    <div class="help-text" :class="position" v-show="show_help_tip && img_data">
      <img src="@/assets/language_profe_help.svg" alt />
    </div>
  </div>
</template>
<script>
export default {
  name: "help",
  components: {},
  props: {
    text: {
      type: String,
      default: "",
    },
    src: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "top right",
    },
  },
  data: () => {
    return {
      data: "",
      img_data: "",
      show_help_tip: false,
    };
  },
  mounted() {
    if (this.text) {
      this.data = this.text;
    }
    if (this.src) {
      this.img_data = this.src;
    }
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.help-tool-tip {
  position: relative;
  .icon {
    cursor: default;
    padding: 0px;
    margin: 0px;
    position: relative;
    top: 2px;
    img {
      width: 13px;
    }
  }
  .help-text {
    position: absolute;
    width: 140px;
    background: #36adae;
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    font-size: 13px;
    text-align: left;
    &.top {
      bottom: 21px;
    }
    &.bottom {
      top: 21px;
    }
    &.left {
      right: 2px;
    }
    &.right {
      left: 2px;
    }
  }
}
</style>
